import { useEffect } from "react";
import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";

export type ToastMessage = {
  tone: "success" | "error" | "info";
  title: string;
  message?: string;
};

const icons = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
};

export function Toast({
  toast,
  onClose,
}: {
  toast: ToastMessage;
  onClose: () => void;
}) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 5_000);
    return () => window.clearTimeout(timer);
  }, [toast, onClose]);

  const Icon = icons[toast.tone];

  return (
    <div className={`toast toast--${toast.tone}`} role="status">
      <Icon size={18} />
      <div className="toast__body">
        <strong>{toast.title}</strong>
        {toast.message ? <span>{toast.message}</span> : null}
      </div>
      <button
        type="button"
        className="toast__close"
        onClick={onClose}
        aria-label="Tutup notifikasi"
      >
        <X size={15} />
      </button>
    </div>
  );
}
